/**
 * Firebase Web SDK config, read from Vite env (VITE_FIREBASE_*). These values
 * are NOT secret — they ship in the client bundle by design. Set them in
 * `.env`/`.env.production` (see PUSH_SETUP.md). When any required field or the
 * VAPID key is missing, web push self-disables (see webPush.ts).
 *
 * The same values must be mirrored into `public/firebase-messaging-sw.js`,
 * which runs in a Service Worker and cannot read import.meta.env.
 */
const env = (import.meta as any).env;

export const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY as string | undefined,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
  projectId: env.VITE_FIREBASE_PROJECT_ID as string | undefined,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID as string | undefined,
  appId: env.VITE_FIREBASE_APP_ID as string | undefined,
};

/** Web Push VAPID public key (Firebase console → Cloud Messaging → Web Push certs). */
export const vapidKey = env.VITE_FIREBASE_VAPID_KEY as string | undefined;

/** True only when every value web push needs is present. */
export const isFirebaseConfigured = (): boolean =>
  Boolean(
    firebaseConfig.apiKey &&
      firebaseConfig.projectId &&
      firebaseConfig.messagingSenderId &&
      firebaseConfig.appId &&
      vapidKey,
  );
